/* PROJ-99 — Geteilter Bearbeiten-Helfer fuer ALLE Editor-Seiten
 * =============================================================
 * Die Warenkorbzeile eines personalisierten Artikels traegt seit PROJ-99 Task A einen
 * „Bearbeiten"-Link auf `<_editor_url>?edit=<Zeilenschluessel>`. Diese Datei ist die Gegenseite:
 * sie erkennt den Modus, besorgt den gespeicherten Zustand und stellt dem Editor drei Dinge
 * bereit — den Zustand selbst, den Knopftext und den Abschluss (alte Zeile entfernen).
 *
 * Sie weiss NICHTS ueber einzelne Editoren. Was mit `config` geschieht, entscheidet allein die
 * Anwendefunktion der jeweiligen Familie (Stadtkarte: `konfigurationAnwenden` in citymap.js).
 *
 * Ablauf
 *   1. `edit` aus URLSearchParams(window.DLEditorSearch || location.search) lesen.
 *      Kein Parameter  -> window.DLCartEdit = null, KEIN einziger Netzaufruf. Das ist der
 *      Normalfall jeder Editor-Seite; er darf nichts kosten.
 *   2. `GET /cart.js`, Zeile ueber `key` suchen (hier ist er noch frisch: der Warenkorb hat ihn
 *      gerade erst gerendert).
 *   3. Zustandsquelle: `properties._config_json` (Schmuck — liegt vollstaendig in der Zeile)
 *      sonst `properties._job_id` -> GET <API>/api/v1/job-config/<uuid>/ (Poster — die
 *      gerenderte Wahrheit vom Render-Server, PROJ-99 Task B).
 *   4. window.DLCartEdit fuellen, `bereit` aufloesen, `dl:cart-edit-ready` feuern.
 *
 * Scheitert irgendein Schritt, geht der Modus AUS (window.DLCartEdit = null) und die Seite
 * verhaelt sich wie ein frisch geoeffneter Editor — plus ein Hinweis, damit der Kunde nicht
 * raetselt, warum sein Motiv nicht da ist.
 *
 * Reihenfolge beim Uebernehmen (Editor-Sache, hier nur der zweite Teil):
 *   erst der normale Einlege-Pfad (neuer Render-Job + /cart/add.js), ERST nach dessen Erfolg
 *   `abschliessen(<add.js-Antwort>)`. Andersherum waere der Warenkorb im Fehlerfall leer.
 *   `abschliessen()` entfernt die alte Zeile NICHT blind: hat Shopify die neue Zeile in die
 *   alte zusammengefuehrt (gleiche Variante, gleiche Eigenschaften -> dieselbe Zeile,
 *   Menge 2), wird nur um eins gekuerzt. Siehe restmengeBestimmen().
 *   Die alte Zeile wird dabei ueber ihre IDENTITAET wiedergefunden (Variante + Eigenschaften),
 *   nicht nur ueber den `key`: der wechselt, sobald sich die Rabatte im Warenkorb aendern —
 *   und genau das passiert beim Uebernehmen (zweite Karte -> Mengenrabatt auf beide).
 *   Siehe zeileFinden().
 *
 * Waehrend der Zustand geladen und angewendet wird, gehoert der Warenkorb-Knopf diesem Helfer:
 *   knopfSperren() -> knopfAnpassen() bei Erfolg, knopfFreigeben() bei Abbruch. Die Editoren
 *   fragen zusaetzlich `istGesperrt()` am Anfang ihres Einlege-Handlers ab.
 *
 * `cart:change` wird hier NIE gefeuert (PROJ-96-Falle: doppelte Drawer-Renders). Nach einem
 * erfolgreichen Abschluss feuert der Helfer GENAU EINMAL `cart:refresh` (das Theme holt den
 * Warenkorb neu: Drawer-Inhalt, Zaehler, Punkt) und oeffnet den seitlichen Drawer — die grosse
 * Warenkorb-Seite soll der Kunde nie sehen (Ansage Dominik 16.08. und 12.09.2026). `/cart` ist
 * nur der Rueckfall, wenn es auf der Seite keinen <cart-drawer> gibt. Der Bearbeiten-Modus ist
 * danach beendet: Knopf wieder „In den Warenkorb", `edit` aus der Adresse, der Editor laeuft
 * als ganz normaler Editor weiter.
 */
(function () {
	'use strict';

	/* ---------------------------------------------------------------- Konstanten */

	/* Die einzigen fest verdrahteten Texte dieser Datei (so vereinbart: es sind keine
	   Shop-Texte mit Theme-Einstellung, sondern Stoerungsmeldungen des Bearbeiten-Modus). */
	var HINWEIS_ZEILE_WEG = 'Diese Warenkorbzeile gibt es nicht mehr.';
	var HINWEIS_KEINE_KONFIGURATION = 'Die gespeicherten Angaben konnten nicht geladen werden. Du kannst frei weitergestalten.';
	/* Dritter Fall (Fix-Runde 1): die NEUE Zeile liegt schon im Warenkorb, nur das Entfernen der
	   alten ist schiefgegangen. Vorher stand hier „gibt es nicht mehr" — das war falsch (die Zeile
	   gibt es sehr wohl) und ohnehin unlesbar, weil sofort danach die Seite wechselte. */
	var HINWEIS_ALTE_ZEILE_BLEIBT = 'Die alte Version konnte nicht entfernt werden. Bitte im Warenkorb prüfen.';
	/* Vierter Fall (I4): die Zeile ist da und lesbar, gehoert aber zu einem anderen Produkt
	   bzw. zu einer anderen Editor-Familie. Der Text lag bisher zweimal im Theme — einmal in
	   jewelry-bearbeiten.js („gehört zu einem anderen Produkt"), einmal als geborgter
	   „Einige Angaben ..."-Text in citymap.js/starmap-celestial.js. Zwei Meldungen fuer
	   denselben Sachverhalt; ab jetzt steht sie hier und alle drei holen sie sich. */
	var HINWEIS_ANDERES_PRODUKT = 'Diese Warenkorbzeile gehört zu einem anderen Produkt. Du kannst hier frei weitergestalten.';

	/* Knopftext im Bearbeiten-Modus. Eine Section darf ihn ueber data-uebernehmen-text am Knopf
	   selbst oder an einem Vorfahren vorgeben; ohne Vorgabe gilt diese Konstante. */
	var KNOPF_UEBERNEHMEN = 'Änderung übernehmen';
	/* Knopftext, solange der gespeicherte Zustand noch geladen und angewendet wird (I1). */
	var KNOPF_LAEDT = 'Wird geladen …';

	/* Render-Server. Dieselbe Umschaltung wie in assets/citymap.js (Z. 50 ff.) und den anderen
	   Editoren — die tragen ihre eigene Kopie, weil sie ohne diese Datei lauffaehig bleiben
	   muessen. Ergebnis liegt als window.DL_API_BASE bereit, damit kuenftige Editoren die
	   Kopie fallen lassen koennen. */
	var USE_LOCAL_SERVER = false;
	var LOCAL_SERVER_URL = 'http://127.0.0.1:8000';
	var PRODUCTION_SERVER_URL = 'https://tiles.distantlines.de';

	function apiBasis() {
		return USE_LOCAL_SERVER ? LOCAL_SERVER_URL : PRODUCTION_SERVER_URL;
	}
	window.DL_API_BASE = apiBasis();

	function shopWurzel() {
		return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
	}

	/* ---------------------------------------------------------------- Hinweis-Element */

	/* Kein Editor hat einen gemeinsamen Hinweis-Bereich (citymap.js und starmap-celestial.js
	   haben je ein eigenes showToast(), die uebrigen gar nichts) — deshalb ein eigenes, kleines
	   Element oberhalb des Editors. Bewusst ohne neue CSS-Datei: ein Stylesheet fuer einen
	   Stoerungsfall waere mehr Aufwand als Nutzen. Die Farben stehen als CSS-Variablen mit
	   Marken-Fallback (Creme/Ink), damit ein Theme sie uebernehmen kann, ohne dass jemand dieses
	   Skript anfassen muss: --dl-hinweis-bg / --dl-hinweis-fg irgendwo im Theme-CSS setzen. */
	/* Der Hinweis steht ganz oben auf der Seite. Der Abschluss passiert aber am Warenkorb-Knopf,
	   und der liegt auf langen Editor-Seiten weit unten — ohne dieses Scrollen bliebe die Meldung
	   ausserhalb des Bildes und der Kunde saehe nur einen Knopf, der nichts tut. `block: 'nearest'`
	   ruckelt nicht, wenn die Seite ohnehin schon oben steht (Seitenaufruf-Faelle). */
	function sichtbarMachen(el) {
		try {
			if (el && typeof el.scrollIntoView === 'function') el.scrollIntoView({ block: 'nearest' });
		} catch (e) { /* aelterer Browser ohne Options-Objekt — der Hinweis steht trotzdem da */ }
	}

	function hinweisZeigen(text) {
		try {
			var vorhanden = document.querySelector('.dl-cart-edit__hinweis');
			if (vorhanden) { vorhanden.textContent = text; sichtbarMachen(vorhanden); return vorhanden; }

			var el = document.createElement('div');
			el.className = 'dl-cart-edit__hinweis';
			el.setAttribute('role', 'status');
			el.textContent = text;
			el.style.cssText = 'margin:12px auto;max-width:900px;padding:10px 14px;border-radius:8px;' +
				'background:var(--dl-hinweis-bg, #eeebe4);color:var(--dl-hinweis-fg, #28292d);' +
				'font-size:14px;line-height:1.4;text-align:center;';

			var ziel = document.querySelector('main') || document.body;
			if (ziel.firstChild) ziel.insertBefore(el, ziel.firstChild);
			else ziel.appendChild(el);
			sichtbarMachen(el);
			return el;
		} catch (e) {
			/* Ein fehlender Hinweis darf den Editor nicht mitreissen. */
			console.warn('[cart-edit] Hinweis konnte nicht angezeigt werden:', e);
			return null;
		}
	}

	/* ---------------------------------------------------------------- Modus erkennen */

	var parameter = new URLSearchParams(window.DLEditorSearch || window.location.search);
	var zeilenSchluessel = parameter.get('edit');

	if (!zeilenSchluessel) {
		/* Normalfall: kein Bearbeiten-Modus. Ab hier passiert nichts mehr — keine Fetches. */
		window.DLCartEdit = null;
		return;
	}

	/* ---------------------------------------------------------------- oeffentliches Objekt */

	var aufloesen;
	var bereit = new Promise(function (res) { aufloesen = res; });

	var DLCartEdit = {
		lineKey: zeilenSchluessel,
		line: null,                 /* die Warenkorbzeile aus /cart.js */
		quelle: null,               /* 'config_json' | 'job' */
		familie: null,              /* 'citymap' | 'starmap' | 'photo' | '<shared product>' | 'schmuck' */
		config: null,               /* der Editor-Zustand (genau das Objekt vom Einlegen) */
		bereit: bereit,             /* Promise<config|null> — Editoren warten darauf */

		/* Seam fuer den Harness: der Abschluss endet mit einem Seitenwechsel, und den kann ein
		   headless-Test nicht abfangen, wenn er direkt in location.assign steckt. */
		navigieren: function (ziel) { window.location.assign(ziel); },

		hinweis: hinweisZeigen,
		HINWEIS_ANDERES_PRODUKT: HINWEIS_ANDERES_PRODUKT,
		knopfSperren: knopfSperren,
		knopfAnpassen: knopfAnpassen,
		knopfZuruecksetzen: knopfZuruecksetzen,
		knopfFreigeben: knopfFreigeben,
		istGesperrt: istGesperrt,
		abschliessen: abschliessen
	};
	window.DLCartEdit = DLCartEdit;

	/* ---------------------------------------------------------------- Knopf */

	/* Der Warenkorb-Knopf durchlaeuft im Bearbeiten-Modus drei Zustaende:
	 *
	 *   knopfSperren()   Seite geladen, Zustand noch nicht da  -> „Wird geladen …", tot
	 *   knopfAnpassen()  Zustand steht im Editor               -> „Änderung übernehmen", frei
	 *   knopfFreigeben() Modus abgebrochen oder beendet        -> Originaltext, frei
	 *
	 * Warum die Sperre (I1): Stadt- und Sternkarte warten bis zu 12 s, bis Karte, Stil und
	 * Schrift wirklich stehen. Ein Klick in dieser Zeit legt den DEFAULT-Stand in den
	 * Warenkorb — und `abschliessen()` entfernt danach die Zeile mit dem Kundenmotiv. Der
	 * Kunde verliert sein Motiv, ohne dass irgendwo etwas schiefgeht.
	 *
	 * Warum die Sperre NICHT ueber die `disabled`-Eigenschaft laeuft: die gehoert den Editoren
	 * selbst (sie sperren den Knopf hart, wenn das Produkt nicht verknuepft ist — Lehre
	 * PROJ-80). Wer sie hier uebernaehme, muesste sie beim Freigeben wieder loeschen und
	 * koennte dabei einen Knopf aufwecken, der tot bleiben soll. Stattdessen: `pointer-events`
	 * gegen echte Klicks, `aria-busy`/`aria-disabled` fuer Screenreader — und die Flagge
	 * `gesperrt`, die die Einlege-Handler der Editoren am Anfang abfragen. Nur sie faengt auch
	 * PROGRAMMATISCHE Klicks ab (die Sternkarte klickt ihren eigenen Knopf aus dem
	 * Druckvorschau-Modal heraus per `cartBtn.click()` — davon weiss `pointer-events` nichts).
	 */
	var gemerkterKnopf = null;
	var gesperrt = false;

	function istGesperrt() {
		return gesperrt;
	}

	/* Originaltext genau EINMAL merken: knopfSperren und knopfAnpassen laufen nacheinander auf
	   demselben Knopf, und der zweite Aufruf duerfte sonst „Wird geladen …" als Original
	   festschreiben. */
	function originaltextMerken(knopf) {
		if (knopf.dataset.dlOriginaltext === undefined) {
			knopf.dataset.dlOriginaltext = knopf.textContent;
		}
	}

	/* Wachhund gegen eine haengende Sperre: bleibt zwischen knopfSperren und knopfAnpassen/
	   knopfFreigeben etwas stecken (nie aufgeloestes bereit, Ausnahme in einem Editor), stuende
	   der Warenkorb-Knopf sonst dauerhaft auf „Wird geladen …" und die Seite waere tot. Nach
	   SPERRE_MAX_MS wird der Modus beendet und der Knopf freigegeben; der Editor laeuft normal
	   weiter. */
	var SPERRE_MAX_MS = 20000;
	var sperreWachhund = null;

	function sperreLoesen(knopf) {
		gesperrt = false;
		if (sperreWachhund) { clearTimeout(sperreWachhund); sperreWachhund = null; }
		if (!knopf) return;
		knopf.removeAttribute('aria-busy');
		knopf.removeAttribute('aria-disabled');
		knopf.style.pointerEvents = 'auto';
	}

	function knopfSperren(knopf, text) {
		if (!knopf) return null;
		gemerkterKnopf = knopf;
		originaltextMerken(knopf);
		knopf.textContent = text || KNOPF_LAEDT;
		knopf.setAttribute('aria-busy', 'true');
		knopf.setAttribute('aria-disabled', 'true');
		knopf.style.pointerEvents = 'none';
		gesperrt = true;
		if (sperreWachhund) clearTimeout(sperreWachhund);
		sperreWachhund = setTimeout(function () {
			sperreWachhund = null;
			if (!gesperrt) return;
			console.warn('[cart-edit] Bearbeiten-Modus haengt (' + SPERRE_MAX_MS + ' ms), Sperre wird geloest.');
			modusAus(HINWEIS_KEINE_KONFIGURATION, 'zeitueberschreitung');
		}, SPERRE_MAX_MS);
		return knopf.textContent;
	}

	/* Setzt den Knopftext auf „Änderung übernehmen", merkt den Originaltext (damit ein Abbruch
	   oder ein Fehlschlag im Einlege-Pfad ihn zurueckholen kann) und hebt die Ladesperre auf. */
	function knopfAnpassen(knopf) {
		if (!knopf) return null;
		gemerkterKnopf = knopf;
		originaltextMerken(knopf);
		var traeger = knopf.closest('[data-uebernehmen-text]');
		var text = (knopf.getAttribute('data-uebernehmen-text') || (traeger && traeger.getAttribute('data-uebernehmen-text')) || '').trim();
		knopf.textContent = text || KNOPF_UEBERNEHMEN;
		knopf.setAttribute('data-dl-modus', 'bearbeiten');
		sperreLoesen(knopf);
		return knopf.textContent;
	}

	function knopfZuruecksetzen(knopf) {
		if (!knopf || knopf.dataset.dlOriginaltext === undefined) return;
		knopf.textContent = knopf.dataset.dlOriginaltext;
	}

	/* ---------------------------------------------------------------- Zeile wiederfinden */

	/* Der `key` einer Warenkorbzeile ist NICHT stabil (Befund 12.09.2026, Dev-Test Dominik:
	   „zwei Karten im Warenkorb statt einer"). Shopify rechnet ihn aus Variante, Eigenschaften
	   UND den zugeteilten Rabatten. Legt das Uebernehmen eine zweite Stadtkarte in den Warenkorb,
	   greift der Mengenrabatt auch auf die ALTE Zeile — und die traegt ab diesem Moment einen
	   anderen Schluessel. Ein reiner key-Vergleich fand sie danach nicht mehr, hielt sie fuer
	   „schon weg" (zweiter Tab) und liess sie liegen; change.js wurde nie gerufen.

	   Was sich NICHT aendert, ist die Identitaet der Zeile: Variante + Eigenschaften (+ Kaufplan).
	   Genau darueber fuehrt Shopify selbst Zeilen zusammen — zwei Zeilen mit derselben Identitaet
	   kann es also nicht geben. Gesucht wird deshalb erst ueber den Schluessel aus der Adresse
	   (frisch, solange sich nichts geaendert hat), dann ueber die Identitaet der beim Start
	   gelesenen Zeile. Verglichen werden ausschliesslich Zeilen, die Shopify selbst geliefert hat
	   (cart.js, add.js, change.js) — dieselbe Darstellung auf beiden Seiten, deshalb ein exakter
	   Vergleich der Eigenschaften und kein Weglassen leerer Werte. */
	function eigenschaftenNormalisiert(eigenschaften) {
		var quelle = (eigenschaften && typeof eigenschaften === 'object') ? eigenschaften : {};
		var namen = Object.keys(quelle).sort();
		var paare = [];
		for (var i = 0; i < namen.length; i++) {
			paare.push([namen[i], quelle[namen[i]] === null || quelle[namen[i]] === undefined ? '' : String(quelle[namen[i]])]);
		}
		return JSON.stringify(paare);
	}

	function kaufplanId(zeile) {
		var zuteilung = zeile && zeile.selling_plan_allocation;
		return (zuteilung && zuteilung.selling_plan && zuteilung.selling_plan.id) || null;
	}

	function zeilenIdentitaetGleich(a, b) {
		if (!a || !b) return false;
		if (String(a.variant_id || a.id) !== String(b.variant_id || b.id)) return false;
		if (kaufplanId(a) !== kaufplanId(b)) return false;
		return eigenschaftenNormalisiert(a.properties) === eigenschaftenNormalisiert(b.properties);
	}

	/* Sucht UNSERE Zeile in einer Zeilenliste (cart.js, add.js-Antwort, change.js-Antwort).
	   Vor dem Start (DLCartEdit.line noch leer) zaehlt nur der Schluessel aus der Adresse. */
	function zeileFinden(zeilen) {
		if (!Array.isArray(zeilen)) return null;
		var i;
		for (i = 0; i < zeilen.length; i++) {
			if (zeilen[i] && zeilen[i].key === zeilenSchluessel) return zeilen[i];
		}
		if (!DLCartEdit.line) return null;
		for (i = 0; i < zeilen.length; i++) {
			if (zeilenIdentitaetGleich(zeilen[i], DLCartEdit.line)) return zeilen[i];
		}
		return null;
	}

	/* ---------------------------------------------------------------- Abschluss */

	/* /cart/add.js antwortet je nach Aufrufform unterschiedlich: auf `{items:[…]}` mit einem
	   Objekt, das `items` traegt, auf die Einzelform mit der Zeile selbst. Beide Formen hier
	   abklopfen und UNSERE Zeile herausgeben — findet sie sich dort, hat Shopify die neue Zeile
	   in die alte zusammengefuehrt. */
	function zeileAusAntwort(antwort) {
		if (!antwort || typeof antwort !== 'object') return null;
		return zeileFinden(Array.isArray(antwort.items) ? antwort.items : [antwort]);
	}

	/* Was change.js bekommen soll — der AKTUELLE Schluessel der alten Zeile und wie viele Stueck
	 * davon nach dem Ersetzen stehen bleiben muessen:
	 *   null                          die Zeile gibt es nicht mehr (zweiter Tab) -> nichts zu tun
	 *   { schluessel, restmenge: 0 }   Normalfall -> Zeile entfernen
	 *   { schluessel, restmenge: n>0 } die neue Zeile wurde in die alte ZUSAMMENGEFUEHRT -> kuerzen
	 *
	 * Der Schluessel kommt aus dem Warenkorb-Nachschlag, nicht aus der Adresse: nach dem Einlegen
	 * kann er ein anderer sein (siehe zeileFinden). Die add.js-Antwort bleibt als Rueckfall, falls
	 * der Nachschlag die Zeile nicht findet, die Antwort sie aber nennt.
	 *
	 * Warum das noetig ist (C1): die neun Schmuck-Editoren schreiben rein deterministische
	 * Eigenschaften (`_config_json`, `_editor_url`, …) — keine Job-ID, keine UUID. Uebernimmt
	 * der Kunde, OHNE etwas geaendert zu haben, ist die neue Zeile Zeichen fuer Zeichen die
	 * alte, und Shopify legt in /cart/add.js keine zweite an, sondern erhoeht die bestehende:
	 * gleicher `key`, Menge 2. Ein blindes `quantity: 0` loeschte dann BEIDE Stueck — der
	 * Warenkorb waere leer, ohne dass irgendwo ein Fehler auftritt.
	 *
	 * Zwei Signale, weil eins allein zu duenn ist: die add.js-Antwort ist sofort da und nennt
	 * den Schluessel direkt; der Warenkorb-Nachschlag deckt die Editoren ab, die ihre Antwort
	 * (noch) nicht durchreichen, und jede Antwortform, die wir nicht kennen. */
	async function restmengeBestimmen(antwortVomEinlegen) {
		var ausAntwort = zeileAusAntwort(antwortVomEinlegen);
		var zeile = await zeileHolen();
		if (!zeile) zeile = ausAntwort;
		if (!zeile) return null;
		var menge = typeof zeile.quantity === 'number' ? zeile.quantity : 1;
		/* Neue personalisierte Zeilen haben immer Menge 1 — der Mengenwaehler ist an ihnen aus
		   (PROJ-99 Task A). Menge > 1 heisst also fast immer: Shopify hat gerade
		   zusammengefuehrt. Die Ausnahme sind ALT-Zeilen von vor PROJ-99, die schon mit Menge
		   2 oder 3 im Warenkorb lagen (Commit e2c5173 zeigt sie deshalb als feste Menge an).
		   Auch fuer die ist „um eins kuerzen" das richtige Verhalten: das Bearbeiten ersetzt
		   GENAU EIN Stueck, die uebrigen bleiben, wie sie waren. `quantity: 0` wuerde dem
		   Kunden dort bezahlte Stuecke wegnehmen, ohne ihn zu fragen. */
		return { schluessel: zeile.key, restmenge: menge > 1 ? menge - 1 : 0 };
	}

	/* Raeumt die ALTE Zeile weg und geht in den Warenkorb. Wird erst gerufen, nachdem die neue
	   Zeile schon drin ist; `antwortVomEinlegen` ist die ausgewertete Antwort von
	   /cart/add.js (optional — ohne sie entscheidet der Warenkorb-Nachschlag allein).
	   Ist die alte Zeile inzwischen weg (zweiter Tab), gilt das als Erfolg — genau das
	   verlangt das Akzeptanzkriterium „kein Fehler zeigen". */
	async function abschliessen(antwortVomEinlegen) {
		try {
			var ziel = await restmengeBestimmen(antwortVomEinlegen);

			if (ziel !== null) {
				var antwort = await fetch(shopWurzel() + 'cart/change.js', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({ id: ziel.schluessel, quantity: ziel.restmenge })
				});

				if (antwort.status === 404) {
					/* Shopify meldet eine unbekannte Zeile mit 404 — sie ist also schon weg.
					   Gilt als Erfolg (zweiter Tab hat sie geloescht). */
					;
				} else if (!antwort.ok) {
					throw new Error('HTTP ' + antwort.status);
				} else {
					var warenkorb = await antwort.json();
					/* Nach dem Entfernen faellt der Mengenrabatt womoeglich wieder weg — der
					   Schluessel kann sich also erneut geaendert haben. Deshalb auch hier ueber die
					   Identitaet suchen, nicht ueber den Schluessel. */
					var nochDa = zeileFinden((warenkorb && Array.isArray(warenkorb.items)) ? warenkorb.items : []);
					if (ziel.restmenge === 0) {
						if (nochDa) throw new Error('Zeile steht nach change.js immer noch im Warenkorb');
					} else if (!nochDa || nochDa.quantity !== ziel.restmenge) {
						throw new Error('Zusammengefuehrte Zeile steht nach change.js nicht auf Menge ' + ziel.restmenge);
					}
				}
			}
		} catch (e) {
			/* Fix-Runde 1: hier NICHT navigieren. Die neue Zeile liegt im Warenkorb, die alte
			   auch — und ein Seitenwechsel wuerde den Hinweis wegreissen, bevor ihn jemand
			   lesen kann. Stattdessen: Hinweis stehen lassen, Knopf wieder freigeben und den
			   Bearbeiten-Modus beenden, damit ein zweiter Klick nicht noch einmal versucht, die
			   alte Zeile zu entfernen (und dabei eine dritte anlegt). */
			console.warn('[cart-edit] Alte Warenkorbzeile konnte nicht entfernt werden:', e);
			hinweisZeigen(HINWEIS_ALTE_ZEILE_BLEIBT);
			knopfFreigeben();
			window.DLCartEdit = null;
			return false;
		}

		/* Erfolg: die alte Zeile ist weg, die neue liegt drin. Modus beenden, Drawer zeigen. */
		modusBeenden();
		drawerZeigen();
		return true;
	}

	/* Nimmt `edit` aus der Adresse, ohne die Seite neu zu laden. Sonst wuerde ein Neuladen (F5,
	   Zurueck-Taste) versuchen, eine Zeile zu bearbeiten, die es nicht mehr gibt, und den Kunden
	   mit „Diese Warenkorbzeile gibt es nicht mehr." begruessen. Andere Parameter bleiben. */
	function adresseBereinigen() {
		try {
			var adresse = new URL(window.location.href);
			if (!adresse.searchParams.has('edit')) return;
			adresse.searchParams.delete('edit');
			window.history.replaceState(window.history.state, '', adresse.toString());
		} catch (e) {
			/* Ohne History-API bleibt die Adresse stehen — der Modus ist trotzdem beendet. */
		}
	}

	/* Beendet den Bearbeiten-Modus nach Erfolg: Knopf zurueck auf seinen Originaltext und frei,
	   Helfer fuer die Editoren unerreichbar (window.DLCartEdit = null), Adresse ohne `edit`. */
	function modusBeenden() {
		knopfFreigeben();
		window.DLCartEdit = null;
		adresseBereinigen();
	}

	/* Zeigt dem Kunden das Ergebnis dort, wo er es beim normalen Einlegen auch sieht: im
	   seitlichen Drawer. `cart:refresh` laesst das Theme den Warenkorb neu holen (Prestige:
	   CartDrawer.refreshCart, CartCount, CartDot) — das ist noetig, weil change.js gerade eine
	   Zeile entfernt hat und der Drawer sonst noch beide zeigte. Rueckfall auf /cart nur, wenn
	   die Seite gar keinen Drawer hat (dann gibt es nichts anderes zu zeigen). */
	function drawerZeigen() {
		document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
		var drawer = document.querySelector('cart-drawer');
		if (drawer && typeof drawer.show === 'function') {
			drawer.show();
			return;
		}
		DLCartEdit.navigieren(shopWurzel() + 'cart');
	}

	/* Macht den Warenkorb-Knopf wieder bedienbar und stellt seinen Originaltext her. Die
	   Editoren sperren ihn waehrend des Einlegens (pointerEvents = 'none'); ohne dieses
	   Zuruecksetzen bliebe die Seite nach einem gescheiterten Abschluss eingefroren. */
	function knopfFreigeben() {
		if (!gemerkterKnopf) { gesperrt = false; return; }
		knopfZuruecksetzen(gemerkterKnopf);
		gemerkterKnopf.removeAttribute('data-dl-modus');
		sperreLoesen(gemerkterKnopf);
	}

	/* ---------------------------------------------------------------- Zustand besorgen */

	function modusAus(hinweisText, grund) {
		/* I1: Hat ein Editor den Knopf schon gesperrt, muss er hier wieder frei werden — sonst
		   bleibt der Warenkorb-Knopf auf „Wird geladen …" stehen und die Seite ist tot, obwohl
		   sie als ganz normaler Editor weiterlaufen soll. Ohne Sperre ist der Aufruf ein No-Op. */
		knopfFreigeben();
		window.DLCartEdit = null;
		if (hinweisText) hinweisZeigen(hinweisText);
		aufloesen(null);
		document.dispatchEvent(new CustomEvent('dl:cart-edit-ready', {
			detail: { ok: false, grund: grund, lineKey: zeilenSchluessel }
		}));
	}

	async function zeileHolen() {
		var antwort = await fetch(shopWurzel() + 'cart.js', {
			headers: { 'Accept': 'application/json' },
			credentials: 'same-origin'
		});
		if (!antwort.ok) throw new Error('cart.js HTTP ' + antwort.status);
		var warenkorb = await antwort.json();
		return zeileFinden((warenkorb && Array.isArray(warenkorb.items)) ? warenkorb.items : []);
	}

	async function jobKonfigurationHolen(jobId) {
		var antwort = await fetch(apiBasis() + '/api/v1/job-config/' + encodeURIComponent(jobId) + '/', {
			headers: { 'Accept': 'application/json' }
		});
		if (!antwort.ok) throw new Error('job-config HTTP ' + antwort.status);
		var daten = await antwort.json();
		if (!daten || typeof daten.config !== 'object' || daten.config === null) {
			throw new Error('job-config ohne config');
		}
		return daten;
	}

	/* Jede unerwartete Ausnahme im Startpfad beendet den Modus sauber (Hinweis, Knopf frei),
	   statt die Sperre stehen zu lassen. */
	(async function starten() {
		try {
			await startenInnen();
		} catch (e) {
			console.warn('[cart-edit] Unerwarteter Fehler beim Start des Bearbeiten-Modus:', e);
			modusAus(HINWEIS_KEINE_KONFIGURATION, 'ausnahme');
		}
	})();

	async function startenInnen() {
		var zeile;
		try {
			zeile = await zeileHolen();
		} catch (e) {
			console.warn('[cart-edit] Warenkorb nicht lesbar:', e);
			modusAus(HINWEIS_ZEILE_WEG, 'cart-unlesbar');
			return;
		}
		if (!zeile) {
			modusAus(HINWEIS_ZEILE_WEG, 'zeile-fehlt');
			return;
		}

		var eigenschaften = zeile.properties || {};

		/* Quelle 1: der Zustand liegt schon in der Zeile (Schmuck-Editoren). */
		if (eigenschaften._config_json) {
			var ausZeile;
			try {
				ausZeile = JSON.parse(eigenschaften._config_json);
			} catch (e) {
				console.warn('[cart-edit] _config_json ist kein gueltiges JSON:', e);
				modusAus(HINWEIS_KEINE_KONFIGURATION, 'config-json-kaputt');
				return;
			}
			if (!ausZeile || typeof ausZeile !== 'object' || Array.isArray(ausZeile)) {
				modusAus(HINWEIS_KEINE_KONFIGURATION, 'config-json-kein-objekt');
				return;
			}
			fertig(zeile, 'config_json', ausZeile.familie || 'schmuck', ausZeile);
			return;
		}

		/* Quelle 2: der Zustand liegt als Render-Job auf dem Server (Poster-Editoren). */
		if (eigenschaften._job_id) {
			var daten;
			try {
				daten = await jobKonfigurationHolen(eigenschaften._job_id);
			} catch (e) {
				console.warn('[cart-edit] Job-Konfiguration nicht abrufbar:', e);
				modusAus(HINWEIS_KEINE_KONFIGURATION, 'job-config-fehlt');
				return;
			}
			fertig(zeile, 'job', daten.familie || null, daten.config);
			return;
		}

		modusAus(HINWEIS_KEINE_KONFIGURATION, 'keine-quelle');
	}

	function fertig(zeile, quelle, familie, config) {
		DLCartEdit.line = zeile;
		DLCartEdit.quelle = quelle;
		DLCartEdit.familie = familie;
		DLCartEdit.config = config;
		aufloesen(config);
		document.dispatchEvent(new CustomEvent('dl:cart-edit-ready', {
			detail: {
				ok: true,
				lineKey: DLCartEdit.lineKey,
				line: zeile,
				quelle: quelle,
				familie: familie,
				config: config
			}
		}));
	}
})();
